import { render } from "./MobileMenuItem.vue?vue&type=template&id=4e57608a&scoped=true&lang=pug"
import script from "./MobileMenuItem.vue?vue&type=script&lang=js"
export * from "./MobileMenuItem.vue?vue&type=script&lang=js"

import "./MobileMenuItem.vue?vue&type=style&index=0&id=4e57608a&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e57608a"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
